import styled from "styled-components";

export default styled.div`
    background-image: linear-gradient(-1.25deg, #00000000, #00000000, #00000000 31.5%, #000 31.7%);

`